import React, { useRef } from "react";
import { useState, useEffect } from "react";
import _ from "lodash";
import { getCustomerFields2 } from "../../../../Services/fieldsServices";
import { useForm, Controller } from 'react-hook-form';
import TextareaElement from '../../../../Components/UiComponents/TextareaElement';
import { get as cusget } from '../../../../Services/customerServices';
import DropdownElement from "../../../../Components/UiComponents/DropdownElement";
import CalendarElement from "../../../../Components/UiComponents/CalendarElement";
import InputTextElementElement from "../../../../Components/UiComponents/InputTextElement";
import RadioElement from "../../../../Components/UiComponents/RadioElement";
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Tooltip } from "primereact/tooltip";
import { useOpportunity } from "../../../../Providers/OpportunityContext";
import moment from "moment";
import ToastElement from "../../../../Components/UiComponents/ToastElement";
import Loader from "../../../../Components/UiComponents/Loader";
import { useNavigate } from "react-router-dom";
import AutoCompleteElement from "../../../../Components/UiComponents/AutoCompleteElement";
import { api } from "../../../../Apis/interceptor";
import { getCustomerDetails } from "../../../../Services/clientService";
import PlaylistVideos from "../../../../Components/Videos/PlaylistVideos";
import { Dialog } from "primereact/dialog";
import ButtonElement from "../../../../Components/UiComponents/ButtonElement";

const Detail = ((props) => {
	const { formState: { errors }, setValue, control } = useForm({
		// defaultValues: {
		// 	opportunity_name: ''
		// }
	});
	const [clientMeetingsOtps, setClientMeetingsOtps] = useState([]);
	const [connectionsToProfessionalTeamOpts, setConnectionsToProfessionalTeamOpts] = useState([]);
	const [subMainContractorBidStatusOpts, setSubMainContractorBidStatusOpts] = useState([]);
	const [frameworkLengthOpts, setFrameworkLengthOpts] = useState([]);
	const [frameworkOpts, setFrameworkOpts] = useState([]);
	const [projectTypeOpts, setProjectTypeOpts] = useState([]);
	const [sourceOfOpportunityOpts, setSourceOfOpportunityOpts] = useState([]);
	const [workTypeOpts, setWorkTypeOpts] = useState([]);
	const [workClassificationV2Opts, setWorkClassificationV2Opts] = useState([]);
	const [formOfContractV1Opts, setFormOfContractV1Opts] = useState([]);
	const [procurementRouteOpts, setProcurementRouteOpts] = useState([]);
	const [sectorV1Opts, setSectorV1Opts] = useState([]);
	const [regionOpts, setRegionOpts] = useState([]);
	const [businessUnitOpts, setBusinessUnitOpts] = useState([]);
	const [editData, setEditData] = useState(null);
	const [customerId, setCustomerId] = useState(null);
	const [customer, setCustomer] = useState({});
	const [branchIdFromLS, setBranchIdFromLS] = useState();
	const [customerTableData, setCustomerTableData] = useState([]);
	const [opportunityData, setOpportunityData] = useState({});
	const [newModule, setNewModule] = useState({});
	const [isSubContract, setIsSubContract] = useState(false);
	const { globalOpportunityData, setGlobalOpportunityData } = useOpportunity();
	const toastRef = useRef();
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate()
	const [selectedFramework, setSelectedFramework] = useState('');
	const [frameworkData, setFrameworkData] = useState([]);
	const [regionsText, setRegionsText] = useState("");
    const [regions, setRegions] = useState([]);
	const [noResults3, setNoResults3] = useState(false);
	const [customerShort, setCustomerShort] = useState(null);
	const [showVideo, setShowVideo] = useState(false);

	const getCustomerData = async (id) =>{
		const customerData = await getCustomerDetails(id);
		if(customerData && customerData.data){
			setCustomerShort(customerData.data.customer_short)
		}
	}
	useEffect(() => {
		const enduserStr = localStorage.getItem("enduser");
		if (enduserStr) {
			const enduser = JSON.parse(enduserStr);
			setCustomer(enduser);
			const customer = enduser.customer;
			getCustomerData(customer)
			setCustomerId(customer);
			const branch = enduser.branch;
			setBranchIdFromLS(branch);
		} else {
			navigate("/login")
			localStorage.clear()
		  }
	}, []);
	useEffect(() => {
		if (opportunityData?.opportunity_name) {
			setValue('opportunity_name', opportunityData.opportunity_name);
		}
	}, [opportunityData, setValue]);

	useEffect(() => {
		if (props?.detailsData?.projectDetailsSections) {
			let obj1 = _.find(props?.detailsData?.projectDetailsSections, { section_name: "Critical Factors" })?.display_name;
			let obj2 = _.find(props?.detailsData?.projectDetailsSections, { section_name: "Critical Data" })?.display_name;
			let obj3 = _.find(props?.detailsData?.projectDetailsSections, { section_name: "Subcontractor Details" })?.display_name;

			var combined = {}
			if (isSubContract) {
				combined = { obj1, obj2, obj3 };
			} else {
				combined = { obj1, obj2 };
			}
			setNewModule(combined);
		}
	}, [props?.detailsData?.projectDetailsSections, isSubContract])

	useEffect(() => {
		if (props.customerId) {
			getCustomerFieldDetails();
			getCustomer();
			transformClientMeetings();
		}
	}, [props.customerId]);

	useEffect(() => {
		if (props.opportunityData) {
			setOpportunityData(props.opportunityData)
		}
	}, [props.opportunityData])

	useEffect(() => {
		if (!_.isEmpty(opportunityData) && clientMeetingsOtps && props.frameworkDetails) {
			getEditData(opportunityData)
			setSelectedFramework(opportunityData.opportunity?.framework_name || " ")
			setRegionsText(opportunityData.additional?.region || '')
		}
	}, [opportunityData, clientMeetingsOtps, props.frameworkDetails])


	const getCustomer = async () => {
		if (props.customerId) {
			setLoading(true);
			try {
				const customer = await cusget(props.customerId);
				if (customer) {
					var customer_type = customer.data.customer_type;
					// clientMeetings
					const referenceData = customer?.data?.reference_data?.find(
						(item) => item.option_names === "ClientMeetings"
					);

					if (referenceData && referenceData.option_choice) {
						const activeOptions = referenceData.option_choice.filter(
							(option) => option.status === "active"
						);
						setClientMeetingsOtps(activeOptions);
					}

					// SubMainContractorBidStatus
					const subMainContractorBidStatus = customer?.data?.reference_data?.find(
						(item) => item.option_names === "SubMainContractorBidStatus"
					);
					if (subMainContractorBidStatus && subMainContractorBidStatus.option_choice) {
						const activeOptions = subMainContractorBidStatus.option_choice.filter(
							(option) => option.status === "active"
						);
						setSubMainContractorBidStatusOpts(activeOptions);
					}

					// isSubContract
					const customerType = customer?.data?.reference_data?.find(
						(item) => item.option_names === "CustomerType"
					);
					if (customerType && customerType.option_choice) {
						const activeOptions = customerType.option_choice.filter(
							(option) => option.status === "active" && option._id === customer_type
						);
						if (activeOptions.some(option => option.label.includes("Sub"))) {
							setIsSubContract(true);
						} else {
							setIsSubContract(false);
						}
					}

					// ConnectionsToProfessionalTeam
					const refDataConnectionsToProfessionalTeam = customer?.data?.reference_data?.find(
						(item) => item.option_names === "ConnectionsToProfessionalTeam"
					);
					if (refDataConnectionsToProfessionalTeam && refDataConnectionsToProfessionalTeam.option_choice) {
						const activeOptions = refDataConnectionsToProfessionalTeam.option_choice.filter(
							(option) => option.status === "active"
						);
						setConnectionsToProfessionalTeamOpts(activeOptions);
					}

					// FrameworkLength
					const refDataFrameworkLength = customer?.data?.reference_data?.find(
						(item) => item.option_names === "FrameworkLength"
					);
					if (refDataFrameworkLength && refDataFrameworkLength.option_choice) {
						const activeOptions = refDataFrameworkLength.option_choice.filter(
							(option) => option.status === "active"
						);
						setFrameworkLengthOpts(activeOptions);
					}

					// Framework
					const refDataFramework = customer?.data?.reference_data?.find(
						(item) => item.option_names === "Framework"
					);
					if (refDataFramework && refDataFramework.option_choice) {
						const activeOptions = refDataFramework.option_choice.filter(
							(option) => option.status === "active"
						);
						setFrameworkOpts(activeOptions);
					}

					// ProjectType
					const refDataProjectType = customer?.data?.reference_data?.find(
						(item) => item.option_names === "ProjectType"
					);
					if (refDataProjectType && refDataProjectType.option_choice) {
						const activeOptions = refDataProjectType.option_choice.filter(
							(option) => option.status === "active"
						);
						setProjectTypeOpts(activeOptions);
					}

					// sourceOfOpportunity
					const refDataSourceOfOpportunity = customer?.data?.reference_data?.find(
						(item) => item.option_names === "SourceOfOpportunity"
					);
					if (refDataSourceOfOpportunity && refDataSourceOfOpportunity.option_choice) {
						const activeOptions = refDataSourceOfOpportunity.option_choice.filter(
							(option) => option.status === "active"
						);
						setSourceOfOpportunityOpts(activeOptions);
					}

					// Wider Staff Commitment
					const refDataWorkType = customer?.data?.reference_data?.find(
						(item) => item.option_names === "WorkType"
					);
					if (refDataWorkType && refDataWorkType.option_choice) {
						const activeOptions = refDataWorkType.option_choice.filter(
							(option) => option.status === "active"
						);
						setWorkTypeOpts(activeOptions);
					}

					// Governance
					const refDataWorkClassificationV2 = customer?.data?.reference_data?.find(
						(item) => item.option_names === "WorkClassificationV2"
					);
					if (refDataWorkClassificationV2 && refDataWorkClassificationV2.option_choice) {
						const activeOptions = refDataWorkClassificationV2.option_choice.filter(
							(option) => option.status === "active"
						);
						setWorkClassificationV2Opts(activeOptions);
					}

					// Business Productivity:
					const refDataFormOfContractV1 = customer?.data?.reference_data?.find(
						(item) => item.option_names === "FormOfContractV1"
					);
					if (refDataFormOfContractV1 && refDataFormOfContractV1.option_choice) {
						const activeOptions = refDataFormOfContractV1.option_choice.filter(
							(option) => option.status === "active"
						);
						setFormOfContractV1Opts(activeOptions);
					}

					// Business Productivity:
					const refDataProcurementRoute = customer?.data?.reference_data?.find(
						(item) => item.option_names === "ProcurementRoute"
					);
					if (refDataProcurementRoute && refDataProcurementRoute.option_choice) {
						const activeOptions = refDataProcurementRoute.option_choice.filter(
							(option) => option.status === "active"
						);
						setProcurementRouteOpts(activeOptions);
					}

					// SectorV1
					const refDataSectorV1 = customer?.data?.reference_data?.find(
						(item) => item.option_names === "SectorV1"
					);
					if (refDataSectorV1 && refDataSectorV1.option_choice) {
						const activeOptions = refDataSectorV1.option_choice.filter(
							(option) => option.status === "active"
						);
						// activeOptions.unshift({ label: "All", status: "active", score: 0 });
						setSectorV1Opts(activeOptions);
					}

					// Region
					const referenceDataRegion = customer?.data?.reference_data?.find(
						(item) => item.option_names === "Region"
					);
					if (referenceDataRegion && referenceDataRegion.option_choice) {
						const activeOptions = referenceDataRegion.option_choice.filter(
							(option) => option.status === "active"
						);
						setRegionOpts(activeOptions);
					}

					// BusinessUnit
					const refDataBusinessUnit = customer?.data?.reference_data?.find(
						(item) => item.option_names === "BusinessUnit"
					);
					if (refDataBusinessUnit && refDataBusinessUnit.option_choice) {
						const activeOptions = refDataBusinessUnit.option_choice.filter(
							(option) => option.status === "active"
						);
						setBusinessUnitOpts(activeOptions);
					}
				}
			} catch (error) {
				toastRef.current.showToast({
					type: "error",
					message: "Error fetching customer details. Please try again or contact Admin",
				});
			} finally {
				setLoading(false);
			}
		}
	};

	const getEditData = (data) => {
		if (data) {
			const edit = _.cloneDeep(data);

			if (edit.opportunity && edit.summary && edit.additional) {
				// edit.opportunity.client_meetings = clientMeetingsOtps.filter(
				// 	(item) => item.label === data.opportunity.client_meetings
				// )[0];
				// edit.opportunity.connections_professional_team = connectionsToProfessionalTeamOpts.filter(
				// 	(item) => item.label === data.opportunity.connections_professional_team
				// )[0];
				edit.opportunity.framework_length = frameworkLengthOpts.filter(
					(item) => item.label === data.opportunity.framework_length
				)[0];
				// edit.opportunity.project_type = projectTypeOpts.filter(
				// 	(item) => item.label === data.opportunity.project_type
				// )[0];
				// edit.opportunity.source_opportunity = sourceOfOpportunityOpts.filter(
				// 	(item) => item.label === data.opportunity.source_opportunity
				// )[0];
				// edit.summary.work_type = workTypeOpts.filter(
				// 	(item) => item.label === data.summary.work_type
				// )[0];
				edit.opportunity.work_classification = workClassificationV2Opts.filter(
					(item) => item.label === data.opportunity.work_classification
				)[0];
				// edit.summary.form_of_contract = formOfContractV1Opts.filter(
				// 	(item) => item.label === data?.summary?.form_of_contract
				// )[0];
				// edit.summary.procurement_route = procurementRouteOpts.filter(
				// 	(item) => item.label === data?.summary?.procurement_route
				// )[0];
				edit.sector = sectorV1Opts.filter(
					(item) => item.label === data.sector
				)[0];
				edit.additional.region = regionOpts.filter(
					(item) => item.label === data?.additional?.region
				)[0];
				edit.business_unit = businessUnitOpts.filter(
					(item) => item.label === data.business_unit
				)[0];
				edit.additional.sub_contractor_main_contractor = subMainContractorBidStatusOpts.filter(
					(item) => item.label === data.additional.sub_contractor_main_contractor
				)[0];

				for (var key of props.frameworkDetails) {
					if (key._id === data.opportunity.framework) {
						edit.opportunity.framework_details = key;
					}
				}
			}

			setEditData(edit);
		}
	}

	const parseDateString = (dateString) => {
		if (dateString) {
			const [day, month, year] = dateString.split('-')?.map(Number);
			return new Date(year, month - 1, day); // Month is 0-indexed in JavaScript Date
		}
	};

	const formatDate = (input) => {
		const date = (input instanceof Date) ? input : new Date(input);
		const day = String(date.getDate()).padStart(2, '0');
		const month = String(date.getMonth() + 1).padStart(2, '0');
		const year = date.getFullYear();
		return `${day}-${month}-${year}`;
	};

	const getCustomerFieldDetails = async () => {
		// Ensure customerId is available before proceeding

		if (props.customerId) {
			setLoading(true);
			try {
				// Fetch customer control field data
				const customerData = await getCustomerFields2(props.customerId);
				if (customerData && customerData?.data?.cust?.[0]?.modules) {
					setCustomerTableData(customerData.data.cust[0].modules);

					// Find project detail fields
					const projectDetailFieldsAll = _.find(
						customerData.data.cust[0].modules,
						{ module_name: "Pipeline" }
					)?.sub_modules;

					const projectDetailFields = _.find(
						projectDetailFieldsAll,
						{ sub_module_name: "Detail" }
					)?.fields;

				} else {
					toastRef.current.showToast({
						type: "error",
						message: "No modules found for the customer data.",
					});
				}
			} catch (error) {
				toastRef.current.showToast({
					type: "error",
					message: "Error fetching customer field details. Please try again or contact Admin",
				});
			} finally {
				setLoading(false);
			}
		} else {
			// If customerId is not available
			toastRef.current.showToast({
				type: "warn",
				message: "No customer ID available. Unable to fetch details.",
			});
		}
	};


	const transformClientMeetings = (clientMeetings) => {
		if (!clientMeetings) return [];
		// If clientMeetings is a string, convert it to an array
		if (typeof clientMeetings === 'string') {
			return [{ label: clientMeetings, value: clientMeetings }];
		}

		// If clientMeetings is an array, map to key-value pairs
		return clientMeetings.map(meeting => ({
			label: meeting,
			value: meeting
		}));
	};

	const handleInputChange = (field, value) => {
		setOpportunityData({
			...opportunityData,
			[field]: {
				...opportunityData[field],
				radio: value
			}
		});
		setGlobalOpportunityData({
			...globalOpportunityData,
			[field]: {
				...globalOpportunityData[field],
				radio: value
			}
		});
	};

	const handleFrameworkInputChange = (field1, field2, value) => {
		setOpportunityData((prevOpportunityDetails) => ({
			...prevOpportunityDetails,
			[field1]: {
				...prevOpportunityDetails[field1],
				[field2]: value,
			},
		}));
		setGlobalOpportunityData((prevGlobalOpportunityData) => ({
			...prevGlobalOpportunityData,
			[field1]: {
				...prevGlobalOpportunityData[field1],
				[field2]: value,
			},
		}));
	};

	const handleOppInputChange = (field, value) => {
		setOpportunityData((prevOpportunityDetails) => ({
			...prevOpportunityDetails,
			[field]: {
				...prevOpportunityDetails[field],
				existing_framework: value,
			},
		}));
		setGlobalOpportunityData((prevOpportunityDetails) => ({
			...prevOpportunityDetails,
			[field]: {
				...prevOpportunityDetails[field],
				existing_framework: value,
			},
		}));
	};

	const handleDetailInputChange = (field1, field2, value) => {
		setOpportunityData((prevOpportunityDetails) => ({
			...prevOpportunityDetails,
			[field1]: {
				...(prevOpportunityDetails[field1] || {}), 
				[field2]: {
					...(prevOpportunityDetails[field1]?.[field2] || {}), 
					radio: value,
				},
			},
		}));
	
		setGlobalOpportunityData((prevGlobalOpportunityData) => ({
			...prevGlobalOpportunityData,
			[field1]: {
				...(prevGlobalOpportunityData[field1] || {}), 
				[field2]: {
					...(prevGlobalOpportunityData[field1]?.[field2] || {}), 
					radio: value, 
				},
			},
		}));
	};

	const handleCalenderInputChange = (field, value) => {
		setOpportunityData((prevOpportunityDetails) => ({
			...prevOpportunityDetails,
			[field]: {
				...prevOpportunityDetails[field],
				text: value
			}
		}));

		setGlobalOpportunityData((prevGlobalOpportunityData) => ({
			...prevGlobalOpportunityData,
			[field]: {
				...prevGlobalOpportunityData[field],
				text: value
			}
		}));

		if (field === 'tender_due' && !_.isUndefined(opportunityData.tender_due_out)) {
			calctenderDuration(value, opportunityData.tender_due_out.text, field);
		} else if (field === 'tender_due_out' && !_.isUndefined(opportunityData.tender_due)) {
			calctenderDuration(opportunityData.tender_due.text, value, field);
		}

	};
	const calctenderDuration = (tender_due, tender_due_out, field) => {
		var opp_contract_start_date = moment(tender_due, "DD.MM.YYYY");
		var opp_contract_end_date = moment(tender_due_out, "DD.MM.YYYY");
		var totalDays = moment(opp_contract_end_date).diff(opp_contract_start_date, "days");
		const weeks = Math.floor(totalDays / 7);
		const days = totalDays % 7;
		var tender_period_text = weeks + " weeks, " + days + " days";
		setOpportunityData((prevOpportunityDetails) => ({
			...prevOpportunityDetails,
			detail: {
				...prevOpportunityDetails.detail,
				tender_period: {
					...prevOpportunityDetails?.detail?.tender_period,
					text: tender_period_text
				}
			}
		}));

		setGlobalOpportunityData((prevGlobalOpportunityData) => ({
			...prevGlobalOpportunityData,
			detail: {
				...prevGlobalOpportunityData.detail,
				tender_period: {
					...prevGlobalOpportunityData?.detail?.tender_period,
					text: tender_period_text
				}
			}
		}));
	}

	const handleCalenderDetailInputChange = (field1, field2, value) => {
		setOpportunityData((prevOpportunityDetails) => ({
			...prevOpportunityDetails,
			[field1]: {
				...(prevOpportunityDetails[field1] || {}),
				[field2]: {
					...(prevOpportunityDetails[field1]?.[field2] || {}), 
					text: value,
				},
			},
		}));
		setGlobalOpportunityData((prevGlobalOpportunityData) => ({
			...prevGlobalOpportunityData,
			[field1]: {
				...(prevGlobalOpportunityData[field1] || {}),
				[field2]: {
					...(prevGlobalOpportunityData[field1]?.[field2] || {}), 
					text: value,
				},
			},
		}));
	};

	const calcProjDuration = (contract_start_date_summary, contract_end_date_summary, field1, field2) => {
		var opp_contract_start_date = moment(contract_start_date_summary, "DD.MM.YYYY");
		var opp_contract_end_date = moment(contract_end_date_summary, "DD.MM.YYYY");

		const totalDays = opp_contract_end_date.diff(opp_contract_start_date, "days");
		const weeks = Math.floor(totalDays / 7);
		const days = totalDays % 7;
		// If totalDays is less than 7, set weeks to 0
		const displayWeeks = totalDays < 0 ? -Math.abs(weeks) : weeks;
		const displayDays = Math.abs(days);
		var project_duration_text = displayWeeks + " weeks, " + displayDays + " days";

		var diffContractStartEndMonths = moment(opp_contract_end_date).diff(opp_contract_start_date, "months");
		let result
		if (diffContractStartEndMonths < 6) {
			result = props.projectDuration[0].label;
		} else if (diffContractStartEndMonths >= 6 && diffContractStartEndMonths < 9) {
			result = props.projectDuration[1].label;
		} else if (diffContractStartEndMonths >= 9 && diffContractStartEndMonths < 12) {
			result = props.projectDuration[2].label;
		} else if (diffContractStartEndMonths >= 12 && diffContractStartEndMonths < 18) {
			result = props.projectDuration[3].label;
		} else if (diffContractStartEndMonths >= 18 && diffContractStartEndMonths < 24) {
			result = props.projectDuration[4].label;
		} else {
			result = props.projectDuration[5].label;
		}

		setOpportunityData((prevOpportunityDetails) => ({
			...prevOpportunityDetails,
			detail: {
				...prevOpportunityDetails?.detail,
				project_duration: {
					...prevOpportunityDetails?.detail?.project_duration,
					text: project_duration_text
				}
			},
			opportunity: {
				...prevOpportunityDetails.opportunity,
				project_duration: result
			},
		}));

		setGlobalOpportunityData((prevGlobalOpportunityData) => ({
			...prevGlobalOpportunityData,
			detail: {
				...prevGlobalOpportunityData.detail,
				project_duration: {
					...prevGlobalOpportunityData?.detail?.project_duration,
					text: project_duration_text
				}
			},
			opportunity: {
				...prevGlobalOpportunityData.opportunity,
				project_duration: result
			},
		}));
	}

	const handleCalenderStartEnd = (field1, field2, value) => {
		setOpportunityData((prevOpportunityDetails) => ({
			...prevOpportunityDetails,
			[field1]: {
				...prevOpportunityDetails[field1],
				[field2]: {
					...prevOpportunityDetails[field1][field2],
					text: value,
				},
			}
		}));

		setGlobalOpportunityData((prevGlobalOpportunityData) => ({
			...prevGlobalOpportunityData,
			[field1]: {
				...prevGlobalOpportunityData[field1],
				[field2]: {
					...prevGlobalOpportunityData[field1][field2],
					text: value,
				},
			}
		}));

		if (field2 === 'contract_start_date_summary' && !_.isUndefined(opportunityData.summary.contract_end_date_summary)) {
			calcProjDuration(value, opportunityData.summary?.contract_end_date_summary?.text, field1, field2);
		} else if (field2 === 'contract_end_date_summary' && !_.isUndefined(opportunityData.summary.contract_start_date_summary)) {
			calcProjDuration(opportunityData.summary?.contract_start_date_summary?.text, value, field1, field2);
		}
	};

	const handleCode = (value) => {
		setGlobalOpportunityData((prevOpportunityDetails) => ({
			...prevOpportunityDetails,
			['additional']: {
				...prevOpportunityDetails['additional'],
				['project_post_code']: value,
			},
		}));
		setValue("project_address", opportunityData?.additional?.project_location + "\n" + value)
	}

	const handleGetFramework = async () => {
		const framworkResponse = await api.get("/api/v1/getFrameworks", {
		  params: { cust_id: props.customerId, searchVal: selectedFramework },
		});
		const frameworkDisplayNames = framworkResponse.data.framework.map(
		  (framework) => framework.framework_display_name
		);
		setFrameworkData(frameworkDisplayNames);
	  };

	  const getRegions = (event) => {
        const val = event?.query;
        let filtered = [];

        if (_.isEmpty(val)) {
            filtered = regionOpts.slice(0, 8);
        } else {
            const lowerCaseVal = val.toLowerCase();
            filtered = regionOpts.filter((item) =>
                item.label.toLowerCase().includes(lowerCaseVal)
            );
        }

        setNoResults3(filtered.length === 0);
        setRegions(filtered);
    };

	const handleButtonClick = () => {
		setShowVideo(true);
	};

	const closeVideo = () => {
		setShowVideo(false);
	};

	return (
		<div>
			<ToastElement ref={toastRef} />
			<Loader loading={loading} />
			<div className="col-md-12 text-right">
                <ButtonElement className="upload-button" type="button" icon="pi pi-video" onClick={handleButtonClick}></ButtonElement>
            </div>
			{
				(!_.isEmpty(opportunityData) && editData) &&
				<form>
					{
						Object.entries(newModule)?.map(([key, value]) => (
							<div key={key} className='mt-10'>
								<Accordion activeIndex={0}>
									{
										<AccordionTab header={value} disabled>
											{
												key == 'obj1' &&
												<div className='new-field d-flex'>
													<div className='col-md-6 pl-0'>
														{_.find(props.detailsData.projectSumFields, { field_name: "Project ID" })?.field_status && (
															<div className="form-group row align-items-center mb-0 mt-0">
																<div className="col-md-5 pl-0">
																	<label className="form-label text-left">{props.detailsData.projectSumFields?.find((project) => project?.field_name === "Project ID")?.display_name}:</label>
																</div>
																<div className='col pr-0'>
																	<label className="form-label text-left">{opportunityData?.opportunity_seq}</label>
																</div>
															</div>
														)}
														{_.find(props.detailsData.projectFieldsNew, { field_name: "Project Name" })?.field_status && (
															<div className="form-group row align-items-center mb-0 mt-0">
																<div className="col-md-5 pl-0">
																	<label className="form-label text-left">{props.detailsData.projectFieldsNew?.find((project) => project?.field_name === "Project Name")?.display_name}:</label>
																</div>
																<div className='col pr-0'>
																	<Controller
																		name="opportunity_name"
																		control={control}
																		defaultValue={opportunityData?.opportunity_name || ''}
																		rules={{ required: "Please Enter Valid Project Name!" }}
																		style={{ innerHeight: 10 }}
																		render={({ field }) => {
																			return (
																				<InputTextElementElement
																					placeholder="Text"
																					name="opportunity_name"
																					className="w-full"
																					{...field}
																					value={field.value || opportunityData?.opportunity_name || ''}
																					onChange={(e) => {
																						setGlobalOpportunityData((prevData) => ({
																							...prevData,
																							opportunity_name: e.target.value
																						}));
																						field.onChange(e.target.value)
																					}
																					}
																				/>
																			);
																		}}
																	/>
																</div>
																{errors.opportunity_name && <div className="text-xs text-red-500 ml-2 mt-0">{errors.opportunity_name.message}</div>}
															</div>
														)}
														{
															_.find(props.detailsData.projectSumFields, { field_name: "Project Description" })?.field_status && (
																<div className="form-group row align-items-center mb-0 mt-0">
																	<div className="col-md-5 pl-0">
																		<label className="form-label text-left">{props.detailsData.projectSumFields?.find((project) => project?.field_name === "Project Description")?.display_name}:</label>
																	</div>
																	<div className='col pr-0'>
																		<Controller
																			name="opportunity_description"
																			control={control}
																			defaultValue={opportunityData?.summary?.opportunity_description}
																			rules={{ required: "Please Enter Valid Project Description!" }}
																			style={{ innerHeight: 10 }}
																			render={({ field }) => {
																				return (
																					<TextareaElement
																						placeholder="Text"
																						name="opportunity_description"
																						className="w-full"
																						{...field}
																						value={field.value !== undefined && field.value !== null ? field.value : opportunityData?.summary?.opportunity_description}
																						rows={3}
																						onChange={(e) => {
																							setGlobalOpportunityData((prevData) => ({
																								...prevData,
																								summary: {
																									...prevData.summary,
																									opportunity_description: e.target.value
																								}
																							}));
																							field.onChange(e.target.value)
																						}
																						}
																					/>
																				);
																			}}
																		/>
																		{errors.opportunity_description && <div className="text-xs text-red-500 ml-2 mt-0">{errors.opportunity_description.message}</div>}
																	</div>
																</div>
															)
														}
														{
															_.find(props.detailsData.projectSelectFields, { field_name: "Project Address" })?.field_status && (
																<div className="form-group row align-items-center mb-0 mt-0">
																	<div className="col-md-4 pl-0">
																		<label className="form-label text-left">{props.detailsData.projectSelectFields?.find((project) => project?.field_name === "Project Address")?.display_name}:</label>
																	</div>
																	<div className="col-md-1 pl-0">
																		{
																			props.customerTooltipDataDetails?.critical_factors?.address.status == true &&
																			<div>
																				<Tooltip target=".custom-target-icon" />
																				<i className="custom-target-icon pi pi-info-circle tooltip-font"
																					data-pr-tooltip={props.customerTooltipDataDetails?.critical_factors?.address.text}
																					data-pr-position="right">
																				</i>
																			</div>
																		}
																	</div>
																	<div className='col pr-0'>
																		<Controller
																			name="project_address"
																			control={control}
																			// defaultValue={opportunityData?.additional?.project_location + ' \n' + opportunityData.additional.project_post_code}
																			defaultValue={
																				((opportunityData?.additional?.project_location || '') +
																					(opportunityData?.additional?.project_post_code ? '\n' + opportunityData.additional.project_post_code : ''))
																			}
																			rules={{ required: "Please Enter Valid Project address!" }}
																			style={{ innerHeight: 10 }}
																			render={({ field }) => {
																				return (
																					<TextareaElement
																						placeholder=""
																						name="project_address"
																						className="w-full"
																						{...field}
																						// value={field.value || opportunityData?.additional?.project_location + ' \n' + opportunityData.additional.project_post_code}
																						value={
																							field.value ||
																							((opportunityData?.additional?.project_location != undefined ? opportunityData?.additional?.project_location : '') +
																								(opportunityData?.additional?.project_post_code ? '\n' + opportunityData.additional.project_post_code : ''))
																						}
																						rows={3}
																						disabled
																					/>
																				);
																			}}
																		/>
																		{errors.project_address && <div className="text-xs text-red-500 ml-2 mt-0">{errors.project_address.message}</div>}
																	</div>
																</div>
															)
														}
														{
															_.find(props.detailsData.projectSelectFields, { field_name: "Project Coordinates" })?.field_status &&
															<div className="form-group row align-items-center mb-0 mt-0">
																<div className="col-md-5 pl-0">
																	<label className="form-label text-left">{props.detailsData.projectSelectFields?.find((project) => project?.field_name === "Project Coordinates")?.display_name}:</label>
																</div>
																<div className='col pr-0'>
																	<Controller
																		name="project_coordinates"
																		control={control}
																		defaultValue={opportunityData?.additional?.project_coordinates}
																		rules={{ required: "Project Coordinates must be 3-25" }}
																		style={{ innerHeight: 10 }}
																		render={({ field }) => {
																			return (
																				<InputTextElementElement
																					placeholder="Text"
																					name="project_coordinates"
																					className="w-full"
																					{...field}
																					value={field.value || opportunityData?.additional?.project_coordinates}
																					disabled
																				/>
																			);
																		}}
																	/>
																</div>
															</div>
														}
														{
															_.find(props.detailsData.projectSelectFields, { field_name: "Project Post Code" })?.field_status &&
															<div className="form-group row align-items-center mb-0 mt-0">
																<div className="col-md-5 pl-0">
																	<label className="form-label text-left">{props.detailsData.projectSelectFields?.find((project) => project?.field_name === "Project Post Code")?.display_name}:</label>
																</div>
																<div className='col pr-0'>
																	<Controller
																		name="project_post_code"
																		control={control}
																		defaultValue={globalOpportunityData?.additional?.project_post_code}
																		rules={{ required: "Should be less than 8 characters & Special Character is not allowed" }}
																		style={{ innerHeight: 10 }}
																		render={({ field }) => {
																			return (
																				<InputTextElementElement
																					placeholder="Text"
																					name="project_post_code"
																					className="w-full"
																					{...field}
																					value={globalOpportunityData.additional?.project_post_code}
																					onChange={(e) => {
																						const newValue = e.target.value;
																						handleCode(newValue);
																						field.onChange(newValue);
																					}}
																				/>
																			);
																		}}
																	/>
																</div>
															</div>
														}
														{
															_.find(props.detailsData.commanFieldsNew, { field_name: "Country" })?.field_status && (
																<div className="form-group row align-items-center mb-0 mt-0">
																	<div className="col-md-4 pl-0">
																		<label className="form-label text-left">{props.detailsData.commanFieldsNew?.find((project) => project?.field_name === "Country")?.display_name}:</label>
																	</div>
																	<div className="col-md-1 pl-0">
																		{
																			props.customerTooltipDataDetails?.critical_factors?.country.status == true &&
																			<div>
																				<Tooltip target=".custom-target-icon" />
																				<i className="custom-target-icon pi pi-info-circle tooltip-font"
																					data-pr-tooltip={props.customerTooltipDataDetails?.critical_factors?.country.text}
																					data-pr-position="right">
																				</i>
																			</div>
																		}
																	</div>
																	<div className='col pr-0'>
																		<Controller
																			name="country"
																			control={control}
																			defaultValue={opportunityData?.opportunity?.country}
																			rules={{ required: "Please Enter Valid Country!" }}
																			style={{ innerHeight: 10 }}
																			render={({ field }) => {
																				return (
																					<InputTextElementElement
																						placeholder="Text"
																						name="country"
																						className="w-full"
																						{...field}
																						value={field.value !== undefined && field.value !== null ? field.value : opportunityData?.opportunity?.country}
																						onChange={(e) => {
																							setGlobalOpportunityData((prevData) => ({
																								...prevData,
																								opportunity: {
																									...prevData.opportunity,
																									country: e.target.value
																								}
																							}));
																							field.onChange(e.target.value)
																						}
																						}
																					/>
																				);
																			}}
																		/>
																		{errors.country && <div className="text-xs text-red-500 ml-2 mt-0">{errors.country.message}</div>}
																	</div>
																</div>
															)}
														{
															_.find(props.detailsData.projectSelectFields, { field_name: "Client meetings" })?.field_status && (
																<div className="form-group row align-items-center mb-0 mt-0">
																	<div className="col-md-5 pl-0">
																		<label className="form-label text-left">{props.detailsData.projectSelectFields?.find((project) => project?.field_name === "Client meetings")?.display_name}:</label>

																	</div>
																	<div className="col-md-7 pr-0 pad-t-8 pad-b-8">
																		<Controller
																			name="ClientMeetings"
																			control={control}
																			defaultValue={clientMeetingsOtps.filter(
																				(item) => item.label === globalOpportunityData?.opportunity?.client_meetings
																			)[0]}
																			style={{ innerHeight: 10 }}
																			render={({ field }) => (
																				<DropdownElement
																					name="ClientMeetings"
																					options={(clientMeetingsOtps != undefined && clientMeetingsOtps.length > 0) ? clientMeetingsOtps : []}
																					optionLabel="label"
																					placeholder="-- Please select --"
																					className="w-full"
																					{...field}
																					maxSelectedLabels={1}
																					value={field.value || clientMeetingsOtps.filter(
																						(item) => item.label === globalOpportunityData?.opportunity?.client_meetings
																					)[0]}
																					// ref={(el) => {
																					// 	props.setElement((prevData) => ({
																					// 		...prevData,
																					// 		["ClientMeetings"]: el,
																					// 	}));
																					// }}
																					onChange={(e) => {
																						setGlobalOpportunityData((prevData) => ({
																							...prevData,
																							opportunity: {
																								...prevData.opportunity,
																								client_meetings: e.value.label
																							}
																						}));
																						props.computeScore(1, "ClientMeetings", e.value, clientMeetingsOtps.filter(
																							(item) => item.label === globalOpportunityData?.opportunity?.client_meetings
																						)[0]);
																						field.onChange(e.value)
																					}
																					}
																				/>
																			)}
																		/>
																	</div>
																</div>
															)
														}
														{
															_.find(props.detailsData.projectSelectFields, { field_name: "Connections to Professional Team" })?.field_status && (
																<div className="form-group row align-items-center mb-0 mt-0">
																	<div className="col-md-5 pl-0">
																		<label className="form-label text-left">{props.detailsData.projectSelectFields?.find((project) => project?.field_name === "Connections to Professional Team")?.display_name}:</label>
																	</div>
																	<div className="col-md-7 pr-0 pad-t-8 pad-b-8">
																		<Controller
																			name="ConnectionsToProfessionalTeam"
																			control={control}
																			defaultValue={connectionsToProfessionalTeamOpts.filter(
																				(item) => item.label === globalOpportunityData?.opportunity?.connections_professional_team
																			)[0]}
																			style={{ innerHeight: 10 }}
																			render={({ field }) => (
																				<DropdownElement
																					onChangeValue={(e) => field.onChange(e.value)}
																					name="ConnectionsToProfessionalTeam"
																					options={(connectionsToProfessionalTeamOpts != undefined && connectionsToProfessionalTeamOpts.length > 0) ? connectionsToProfessionalTeamOpts : []}
																					optionLabel="label"
																					placeholder="-- Please select --"
																					className="w-full"
																					{...field}
																					maxSelectedLabels={1}
																					value={field.value || connectionsToProfessionalTeamOpts.filter(
																						(item) => item.label === globalOpportunityData?.opportunity?.connections_professional_team
																					)[0]}
																					// ref={(el) => {
																					// 	props.setElement((prevData) => ({
																					// 		...prevData,
																					// 		["ConnectionsToProfessionalTeam"]: el,
																					// 	}));
																					// }}
																					onChange={(e) => {
																						setGlobalOpportunityData((prevData) => ({
																							...prevData,
																							opportunity: {
																								...prevData.opportunity,
																								connections_professional_team: e.value.label
																							}
																						}));
																						props.computeScore(1, "ConnectionsToProfessionalTeam", e.value, connectionsToProfessionalTeamOpts.filter(
																							(item) => item.label === globalOpportunityData?.opportunity?.connections_professional_team
																						)[0]);
																						field.onChange(e.value)
																					}
																					}
																				/>
																			)}
																		/>
																	</div>
																</div>
															)
														}
														{
															_.find(props.detailsData.projectSelectFields, { field_name: "Framework Opportunity" })?.field_status && (
																<div className="form-group row align-items-center mb-0 mt-0">
																	<div className="col-md-5 pl-0">
																		<label className="form-label text-left">{props.detailsData.projectSelectFields?.find((project) => project?.field_name === "Framework Opportunity")?.display_name}:</label>
																	</div>
																	<div className="col pr-0">
																		<RadioElement
																			id="existing_framework"
																			options={[{ key: 'Yes', name: "Yes" }, { key: 'No', name: "No" }]}
																			value={opportunityData.opportunity?.existing_framework}
																			onChangeRadio={(value) => {
																				handleFrameworkInputChange("opportunity", "existing_framework", value);
																			}}
																			className="radio-group-class"
																		/>
																	</div>
																</div>
															)
														}
														{
															opportunityData.opportunity?.existing_framework === "Yes" && _.find(props.detailsData.frameworkFieldsNew, { field_name: "Framework" })?.field_status &&
															<div className="form-group row align-items-center mb-0 mt-0">
																<div className="col-md-4 pl-0">
																	<label className="form-label text-left">{_.find(props.detailsData.frameworkFieldsNew, { field_name: "Framework" })?.display_name}</label>
																</div>
																<div className="col-md-1 pl-0">
                                                                        {props.customerTooltipDataDetails?.opportunity?.framework
                                                                            ?.status == true && (
                                                                                <div>
                                                                                    <Tooltip target=".custom-target-icon" />
                                                                                    <i
                                                                                        className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                        data-pr-tooltip={
                                                                                            props.customerTooltipDataDetails?.opportunity
                                                                                                ?.framework?.text
                                                                                        }
                                                                                        data-pr-position="right"
                                                                                    ></i>
                                                                                </div>
                                                                            )}
                                                                    </div>
																{/* <div className='col-md-7 pr-0 pad-t-8 pad-b-8'>
																	<Controller
																		name="framework"
																		control={control}
																		defaultValue={editData.opportunity?.framework_details}
																		style={{ innerHeight: 10 }}
																		render={({ field }) => {
																			return (
																				<DropdownElement
																					onChangeValue={(e) => field.onChange(e.value)}
																					name="framework"
																					options={props.frameworkDetails}
																					optionLabel="framework_display_name"
																					placeholder="-- Please select --"
																					className="w-full"
																					{...field}
																					maxSelectedLabels={1}
																					value={field.value || editData.opportunity?.framework_details}
																					onChange={(e) => {
																						setGlobalOpportunityData((prevData) => ({
																							...prevData,
																							opportunity: {
																								...prevData.opportunity,
																								framework: e.value._id
																							}
																						}));
																						field.onChange(e.value)
																					}
																					}
																				/>
																			);
																		}}
																	/>
																</div> */}
																<div className="col pr-0">
																	<AutoCompleteElement
																		value={selectedFramework}
																		onChangeValue={(e) => {
																			setGlobalOpportunityData((prevData) => ({
																				...prevData,
																				opportunity: {
																					...prevData.opportunity,
																					framework_name: e.value
																				}
																			}));
																			setSelectedFramework(e.value)
																		}}
																		placeholder="Enter Framework Name"
																		suggestions={frameworkData}
																		completeMethod={handleGetFramework}
																		className="w-full"
																		autocomplete="off"
																		isPurposeScore={true}
																	/>
																</div>
															</div>
														}
														{
															opportunityData.opportunity?.existing_framework === "Yes" && _.find(props.detailsData.projectSelectFields, { field_name: "Framework Length" })?.field_status && (
																<div className="form-group row align-items-center mb-0 mt-0">
																	<div className="col-md-4 pl-0">
																		<label className="form-label text-left">{props.detailsData.projectSelectFields?.find((project) => project?.field_name === "Framework Length")?.display_name}:</label>
																	</div>
																	<div className="col-md-1 pl-0">
																		{
																			props.customerTooltipDataDetails?.critical_factors?.framework_length.status == true &&
																			<div>
																				<Tooltip target=".custom-target-icon" />
																				<i className="custom-target-icon pi pi-info-circle tooltip-font"
																					data-pr-tooltip={props.customerTooltipDataDetails?.critical_factors?.framework_length.text}
																					data-pr-position="right">
																				</i>
																			</div>
																		}
																	</div>
																	<div className="col-md-7 pr-0 pad-t-8 pad-b-8">
																		<Controller
																			name="framework_length"
																			control={control}
																			defaultValue={editData.opportunity?.framework_length}
																			style={{ innerHeight: 10 }}
																			render={({ field }) => (
																				<DropdownElement
																					onChangeValue={(e) => field.onChange(e.value)}
																					name="framework_length"
																					options={(frameworkLengthOpts != undefined && frameworkLengthOpts.length > 0) ? frameworkLengthOpts : []}
																					optionLabel="label"
																					placeholder="-- Please select --"
																					className="w-full"
																					{...field}
																					maxSelectedLabels={1}
																					value={field.value || editData.opportunity?.framework_length}
																					onChange={(e) => {
																						setGlobalOpportunityData((prevData) => ({
																							...prevData,
																							opportunity: {
																								...prevData.opportunity,
																								framework_length: e.value.label
																							}
																						}));
																						field.onChange(e.value)
																					}
																					}
																				/>
																			)}
																		/>
																	</div>
																</div>
															)
														}
													</div>
													<div className='col-md-6 pl-0'>
														{
															_.find(props.detailsData.projectSelectFields, { field_name: "Project Type" })?.field_status && (
																<div className="form-group row align-items-center mb-0 mt-0">
																	<div className="col-md-5 pl-0">
																		<label className="form-label text-left">{props.detailsData.projectSelectFields?.find((project) => project?.field_name === "Project Type")?.display_name}:</label>
																	</div>
																	<div className="col-md-7 pr-0 pad-t-8 pad-b-8">
																		<Controller
																			name="ProjectType"
																			control={control}
																			defaultValue={projectTypeOpts.filter(
																				(item) => item.label === globalOpportunityData?.opportunity?.project_type
																			)[0]}
																			style={{ innerHeight: 10 }}
																			render={({ field }) => (
																				<DropdownElement
																					onChangeValue={(e) => field.onChange(e.value)}
																					id="ProjectType"
																					options={(projectTypeOpts != undefined && projectTypeOpts.length > 0) ?  projectTypeOpts : []}
																					optionLabel="label"
																					placeholder="-- Please select --"
																					className="w-full"
																					{...field}
																					maxSelectedLabels={1}
																					value={field.value || projectTypeOpts.filter(
																						(item) => item.label === globalOpportunityData?.opportunity?.project_type
																					)[0]}
																					// ref={(el) => {
																					// 	props.setElement((prevData) => ({
																					// 		...prevData,
																					// 		["ProjectType"]: el,
																					// 	}));
																					// }}
																					onChange={(e) => {
																						setGlobalOpportunityData((prevData) => ({
																							...prevData,
																							opportunity: {
																								...prevData.opportunity,
																								project_type: e.value.label
																							}
																						}));
																						props.computeScore(1, "ProjectType", e.value, projectTypeOpts.filter(
																							(item) => item.label === globalOpportunityData?.opportunity?.project_type
																						)[0]);
																						field.onChange(e.value)
																					}
																					}
																				/>
																			)}
																		/>
																	</div>
																</div>
															)
														}
														{
															_.find(props.detailsData.projectSelectFields, { field_name: "Source of Opportunity" })?.field_status && (
																<div className="form-group row align-items-center mb-0 mt-0">
																	<div className="col-md-5 pl-0">
																		<label className="form-label text-left">{props.detailsData.projectSelectFields?.find((project) => project?.field_name === "Source of Opportunity")?.display_name}:</label>
																	</div>
																	<div className="col-md-7 pr-0 pad-t-8 pad-b-8">
																		<Controller
																			name="SourceOfOpportunity"
																			control={control}
																			defaultValue={sourceOfOpportunityOpts.filter(
																				(item) => item.label === globalOpportunityData?.opportunity?.source_opportunity
																			)[0]}
																			style={{ innerHeight: 10 }}
																			render={({ field }) => (
																				<DropdownElement
																					onChangeValue={(e) => field.onChange(e.value)}
																					id="SourceOfOpportunity"
																					options={(sourceOfOpportunityOpts != undefined && sourceOfOpportunityOpts.length > 0) ? sourceOfOpportunityOpts : []}
																					optionLabel="label"
																					placeholder="-- Please select --"
																					className="w-full"
																					{...field}
																					maxSelectedLabels={1}
																					value={field.value || sourceOfOpportunityOpts.filter(
																						(item) => item.label === globalOpportunityData?.opportunity?.source_opportunity
																					)[0]}
																					// ref={(el) => {
																					// 	props.setElement((prevData) => ({
																					// 		...prevData,
																					// 		["SourceOfOpportunity"]: el,
																					// 	}));
																					// }}
																					onChange={(e) => {
																						setGlobalOpportunityData((prevData) => ({
																							...prevData,
																							opportunity: {
																								...prevData.opportunity,
																								source_opportunity: e.value.label
																							}
																						}));
																						props.computeScore(1, "SourceOfOpportunity", e.value, sourceOfOpportunityOpts.filter(
																							(item) => item.label === globalOpportunityData?.opportunity?.source_opportunity
																						)[0]);
																						field.onChange(e.value)
																					}
																					}
																				/>
																			)}
																		/>
																	</div>
																</div>
															)
														}
														{
															_.find(props.detailsData.projectSumFields, { field_name: "Work Type" })?.field_status && (
																<div className="form-group row align-items-center mb-0 mt-0">
																	<div className="col-md-5 pl-0">
																		<label className="form-label text-left">{props.detailsData.projectSumFields?.find((project) => project?.field_name === "Work Type")?.display_name}:</label>
																	</div>
																	<div className="col-md-7 pr-0 pad-t-8 pad-b-8">
																		<Controller
																			name="WorkType"
																			control={control}
																			defaultValue={workTypeOpts.filter(
																				(item) => item.label === globalOpportunityData?.summary?.work_type
																			)[0]}
																			style={{ innerHeight: 10 }}
																			render={({ field }) => (
																				<DropdownElement
																					onChangeValue={(e) => field.onChange(e.value)}
																					id="WorkType"
																					options={(workTypeOpts != undefined && workTypeOpts.length > 0) ? workTypeOpts : []}
																					optionLabel="label"
																					placeholder="-- Please select --"
																					className="w-full"
																					{...field}
																					maxSelectedLabels={1}
																					value={field.value || workTypeOpts.filter(
																						(item) => item.label === globalOpportunityData?.summary?.work_type
																					)[0]}
																					// ref={(el) => {
																					// 	props.setElement((prevData) => ({
																					// 		...prevData,
																					// 		["WorkType"]: el,
																					// 	}));
																					// }}
																					onChange={(e) => {
																						setGlobalOpportunityData((prevData) => ({
																							...prevData,
																							summary: {
																								...prevData.summary,
																								work_type: e.value.label
																							}
																						}));
																						props.computeScore(2, "WorkType", e.value, workTypeOpts.filter(
																							(item) => item.label === globalOpportunityData?.summary?.work_type
																						)[0]);
																						field.onChange(e.value)
																					}
																					}
																				/>
																			)}
																		/>
																	</div>
																</div>
															)
														}
														{
															_.find(props.detailsData.commanFieldsNew, { field_name: "Work Classification" })?.field_status && (
																<div className="form-group row align-items-center mb-0 mt-0">
																	<div className="col-md-5 pl-0">
																		<label className="form-label text-left">{props.detailsData.commanFieldsNew?.find((project) => project?.field_name === "Work Classification")?.display_name}:</label>
																	</div>
																	<div className="col-md-7 pr-0 pad-t-8 pad-b-8">
																		<Controller
																			name="work_classification"
																			control={control}
																			defaultValue={editData.opportunity?.work_classification}
																			style={{ innerHeight: 10 }}
																			render={({ field }) => (
																				<DropdownElement
																					onChangeValue={(e) => field.onChange(e.value)}
																					id="work_classification"
																					options={(workClassificationV2Opts != undefined && workClassificationV2Opts.length > 0) ? workClassificationV2Opts : []}
																					optionLabel="label"
																					placeholder="-- Please select --"
																					className="w-full"
																					{...field}
																					maxSelectedLabels={1}
																					value={field.value || editData.opportunity?.work_classification}
																					onChange={(e) => {
																						setGlobalOpportunityData((prevData) => ({
																							...prevData,
																							opportunity: {
																								...prevData.opportunity,
																								work_classification: e.value.label
																							}
																						}));
																						field.onChange(e.value)
																					}
																					}
																				/>
																			)}
																		/>
																	</div>
																</div>
															)
														}
														{
															_.find(props.detailsData.projectSumFields, { field_name: "Form of Contract" })?.field_status && (
																<div className="form-group row align-items-center mb-0 mt-0">
																	<div className="col-md-5 pl-0">
																		<label className="form-label text-left">{props.detailsData.projectSumFields?.find((project) => project?.field_name === "Form of Contract")?.display_name}:</label>
																	</div>
																	<div className="col-md-7 pr-0 pad-t-8 pad-b-8">
																		<Controller
																			name="FormOfContractV1"
																			control={control}
																			defaultValue={formOfContractV1Opts.filter(
																				(item) => item.label === globalOpportunityData?.summary?.form_of_contract
																			)[0]}
																			style={{ innerHeight: 10 }}
																			render={({ field }) => (
																				<DropdownElement
																					onChangeValue={(e) => field.onChange(e.value)}
																					id="FormOfContractV1"
																					options={(formOfContractV1Opts != undefined && formOfContractV1Opts.length > 0) ? formOfContractV1Opts : []}
																					optionLabel="label"
																					placeholder="-- Please select --"
																					className="w-full"
																					{...field}
																					maxSelectedLabels={1}
																					value={field.value || formOfContractV1Opts.filter(
																						(item) => item.label === globalOpportunityData?.summary?.form_of_contract
																					)[0]}
																					// ref={(el) => {
																					// 	props.setElement((prevData) => ({
																					// 		...prevData,
																					// 		["FormOfContractV1"]: el,
																					// 	}));
																					// }}
																					onChange={(e) => {
																						setGlobalOpportunityData((prevData) => ({
																							...prevData,
																							summary: {
																								...prevData.summary,
																								form_of_contract: e.value.label
																							}
																						}));
																						props.computeScore(2, "FormOfContractV1", e.value, formOfContractV1Opts.filter(
																							(item) => item.label === globalOpportunityData?.summary?.form_of_contract
																						)[0]);
																						field.onChange(e.value)
																					}
																					}
																				/>
																			)}
																		/>
																	</div>
																</div>
															)
														}
														{
															_.find(props.detailsData.projectSumFields, { field_name: "Procurement Route" })?.field_status && (
																<div className="form-group row align-items-center mb-0 mt-0">
																	<div className="col-md-5 pl-0">
																		<label className="form-label text-left">{props.detailsData.projectSumFields?.find((project) => project?.field_name === "Procurement Route")?.display_name}:</label>
																	</div>
																	<div className="col-md-7 pr-0 pad-t-8 pad-b-8">
																		<Controller
																			name="ProcurementRoute"
																			control={control}
																			defaultValue={procurementRouteOpts.filter(
																				(item) => item.label === globalOpportunityData?.summary?.procurement_route
																			)[0]}
																			style={{ innerHeight: 10 }}
																			render={({ field }) => (
																				<DropdownElement
																					onChangeValue={(e) => field.onChange(e.value)}
																					id="ProcurementRoute"
																					options={(procurementRouteOpts != undefined && procurementRouteOpts.length > 0) ? procurementRouteOpts : []}
																					optionLabel="label"
																					placeholder="-- Please select --"
																					className="w-full"
																					{...field}
																					maxSelectedLabels={1}
																					value={field.value || procurementRouteOpts.filter(
																						(item) => item.label === globalOpportunityData?.summary?.procurement_route
																					)[0]}
																					// ref={(el) => {
																					// 	props.setElement((prevData) => ({
																					// 		...prevData,
																					// 		["ProcurementRoute"]: el,
																					// 	}));
																					// }}
																					onChange={(e) => {
																						setGlobalOpportunityData((prevData) => ({
																							...prevData,
																							summary: {
																								...prevData.summary,
																								procurement_route: e.value.label
																							}
																						}));
																						props.computeScore(2, "ProcurementRoute", e.value, procurementRouteOpts.filter(
																							(item) => item.label === globalOpportunityData?.summary?.procurement_route
																						)[0]);
																						field.onChange(e.value)
																					}
																					}
																				/>
																			)}
																		/>
																	</div>
																</div>
															)
														}
														{
															_.find(props.detailsData.commanFieldsNew, { field_name: "Sector" })?.field_status && (
																<div className="form-group row align-items-center mb-0 mt-0">
																	<div className="col-md-5 pl-0">
																		<label className="form-label text-left">{props.detailsData.commanFieldsNew?.find((project) => project?.field_name === "Sector")?.display_name}:</label>
																	</div>
																	<div className="col-md-7 pr-0 pad-t-8 pad-b-8">
																		<Controller
																			name="sector"
																			control={control}
																			defaultValue={editData.sector}
																			style={{ innerHeight: 10 }}
																			render={({ field }) => (
																				<DropdownElement
																					onChangeValue={(e) => field.onChange(e.value)}
																					name="sector"
																					options={(sectorV1Opts != undefined && sectorV1Opts.length > 0) ? sectorV1Opts : []}
																					optionLabel="label"
																					placeholder="-- Please select --"
																					className="w-full"
																					{...field}
																					maxSelectedLabels={1}
																					value={field.value || editData.sector}
																					onChange={(e) => {
																						setGlobalOpportunityData((prevData) => ({
																							...prevData,
																							sector: e.value.label
																						}));
																						field.onChange(e.value)
																					}
																					}
																				/>
																			)}
																		/>
																	</div>
																</div>
															)
														}
														{
															_.find(props.detailsData.commanFieldsNew, { field_name: "Region" })?.field_status &&
															<div className="form-group row align-items-center mb-0 mt-0">
																<div className="col-md-4 pl-0">
																	<label className="form-label text-left">{props.detailsData.commanFieldsNew?.find((project) => project?.field_name === "Region")?.display_name}:</label>
																</div>
																<div className="col-md-1 pl-0">
                                                                        {props.customerTooltipDataDetails?.additional?.region
                                                                            ?.status == true && (
                                                                                <div>
                                                                                    <Tooltip target=".custom-target-icon" />
                                                                                    <i
                                                                                        className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                        data-pr-tooltip={
                                                                                            props.customerTooltipDataDetails?.additional?.region
                                                                                                ?.text
                                                                                        }
                                                                                        data-pr-position="right"
                                                                                    ></i>
                                                                                </div>
                                                                            )}
                                                                    </div>
																<div className="col pr-0">
																	{/* <Controller
																		name="region"
																		control={control}
																		defaultValue={editData.additional?.region}
																		style={{ innerHeight: 10 }}
																		render={({ field }) => (
																			<DropdownElement
																				onChangeValue={(e) => field.onChange(e.value)}
																				id="region"
																				options={regionOpts}
																				optionLabel="label"
																				placeholder="-- Please select --"
																				className="w-full"
																				{...field}
																				maxSelectedLabels={1}
																				value={field.value || editData.additional?.region}
																				onChange={(e) => {
																					setGlobalOpportunityData((prevData) => ({
																						...prevData,
																						additional: {
																							...prevData.additional,
																							region: e.value.label
																						}
																					}));
																					field.onChange(e.value)
																				}
																				}
																			/>
																		)}
																	/> */}
																	 <AutoCompleteElement
                                                                            value={regionsText}
                                                                            onChangeValue={(e) => {
                                                                                setGlobalOpportunityData((prevData) => ({
                                                                                    ...prevData,
                                                                                    additional: {
                                                                                        ...prevData.additional,
                                                                                        region: e.value,
                                                                                    }
                                                                                }))
                                                                                setRegionsText(e.value)
                                                                            }} // Set the value when user types
                                                                            placeholder="Region"
                                                                            suggestions={regions.map(
                                                                                (region) => region.label
                                                                            )} // Use .label to ensure it's a string
                                                                            completeMethod={getRegions} // Call getRegions to filter the suggestions
                                                                            className="w-full"
                                                                             autocomplete="off"
                                                                            isPurposeScore={true}
                                                                        />
																</div>
															</div>
														}
														{
															_.find(props.detailsData.commanFieldsNew, { field_name: "Business Unit" })?.field_status &&
															<div className="form-group row align-items-center mb-0 mt-0">
																<div className="col-md-5 pl-0">
																	<label className="form-label text-left">{props.detailsData.commanFieldsNew?.find((project) => project?.field_name === "Business Unit")?.display_name}:</label>
																</div>
																<div className="col-md-7 pr-0 pad-t-8 pad-b-8">
																	<Controller
																		name="business_unit"
																		control={control}
																		defaultValue={editData?.business_unit}
																		style={{ innerHeight: 10 }}
																		render={({ field }) => (
																			<DropdownElement
																				onChangeValue={(e) => field.onChange(e.value)}
																				id="business_unit"
																				options={(businessUnitOpts != undefined && businessUnitOpts.length > 0) ? businessUnitOpts : []}
																				optionLabel="label"
																				placeholder="-- Please select --"
																				className="w-full"
																				{...field}
																				maxSelectedLabels={1}
																				value={field.value || editData.business_unit}
																				onChange={(e) => {
																					setGlobalOpportunityData((prevData) => ({
																						...prevData,
																						business_unit: e.value.label
																					}));
																					field.onChange(e.value)
																				}
																				}
																			/>
																		)}
																	/>
																</div>
															</div>
														}
													</div>
												</div>
											}
											{
												key == 'obj2' &&
												<div className="new-field d-flex">
													<div className='col-md-6 pl-0'>
														{
															_.find(props.detailsData.projectDetailFields, { field_name: "Project/EOI Received Date" })?.field_status &&
															<div className="form-group row align-items-center mb-0 mt-0">
																<div className="col-md-4 pl-0">
																	<label className="form-label text-left">{props.detailsData.projectDetailFields.find((project) => project?.field_name === "Project/EOI Received Date")?.display_name}:</label>
																</div>
																<div className="col-md-1 pl-0">
																</div>
																<div className='col pr-0 d-flex'>
																	<RadioElement
																		name="eoi_received_date"
																		options={[{ key: "Est", name: "Est" }, { key: "Act", name: "Act" }]}
																		value={opportunityData?.detail?.eoi_received_date?.radio}
																		onChangeRadio={(value) => {
																			handleDetailInputChange("detail", "eoi_received_date", value);
																		}}
																		// onChangeRadio={(value) => {
																		//     handleInputChange("tender_due", value);
																		// }}
																		className="radio-group-class"
																	/>
																	<CalendarElement
																		id="eoi_received_date"
																		className='ml-10'
																		defaultValue={parseDateString(opportunityData?.detail?.eoi_received_date?.text)}
																		value={parseDateString(opportunityData?.detail?.eoi_received_date?.text)}
																		onChange={(value) => {
																			handleCalenderDetailInputChange("detail", "eoi_received_date", formatDate(value.value));
																		}}
																		maxLength="50"
																		placeholder="Date"
																		autocomplete="off"
																	/>
																</div>
															</div>
														}
														{
															_.find(props.detailsData?.projectDetailFields, { field_name: "PQQ Issue Date" })?.field_status &&
															<div className="form-group row align-items-center mb-0 mt-0">
																<div className="col-md-4 pl-0">
																	<label className="form-label text-left">{props.detailsData?.projectDetailFields.find((project) => project?.field_name === "PQQ Issue Date")?.display_name}:</label>
																</div>
																<div className="col-md-1 pl-0">
																	{
																		props.customerTooltipDataDetails?.critical_data?.pqq_issue_date?.status == true &&
																		<div>
																			<Tooltip target=".custom-target-icon" />
																			<i className="custom-target-icon pi pi-info-circle tooltip-font"
																				data-pr-tooltip={props.customerTooltipDataDetails?.critical_data?.pqq_issue_date?.text}
																				data-pr-position="right">
																			</i>
																		</div>
																	}
																</div>
																<div className='col pr-0 d-flex'>
																	<RadioElement
																		id="pqq_issue_date"
																		options={[{ key: "Est", name: "Est" }, { key: "Act", name: "Act" }]}
																		value={opportunityData?.detail?.pqq_issue_date?.radio}
																		onChangeRadio={(value) => {
																			handleDetailInputChange("detail", "pqq_issue_date", value);
																		}}
																		className="radio-group-class"
																	/>
																	<CalendarElement
																		id="pqq_issue_date"
																		className='ml-10'
																		defaultValue={parseDateString(opportunityData?.detail?.pqq_issue_date?.text)}
																		value={parseDateString(opportunityData?.detail?.pqq_issue_date?.text)}
																		onChange={(value) => {
																			handleCalenderDetailInputChange("detail", "pqq_issue_date", formatDate(value.value));
																		}}
																		maxLength="50"
																		placeholder="Date"
																		autocomplete="off"
																	/>
																</div>
															</div>
														}
														{
															_.find(props.detailsData?.projectDetailFields, { field_name: "PQQ Submission Date" })?.field_status &&
															<div className="form-group row align-items-center mb-0 mt-0">
																<div className="col-md-4 pl-0">
																	<label className="form-label text-left">{props.detailsData?.projectDetailFields.find((project) => project?.field_name === "PQQ Submission Date")?.display_name}:</label>
																</div>
																<div className="col-md-1 pl-0">
																	{
																		props.customerTooltipDataDetails?.critical_data?.pqq_submission_date?.status == true &&
																		<div>
																			<Tooltip target=".custom-target-icon" />
																			<i className="custom-target-icon pi pi-info-circle tooltip-font"
																				data-pr-tooltip={props.customerTooltipDataDetails?.critical_data?.pqq_submission_date?.text}
																				data-pr-position="right">
																			</i>
																		</div>
																	}
																</div>
																<div className='col pr-0 d-flex'>
																	<RadioElement
																		id="pqq_submission_date"
																		options={[{ key: "Est", name: "Est" }, { key: "Act", name: "Act" }]}
																		value={opportunityData?.detail?.pqq_submission_date?.radio}
																		onChangeRadio={(value) => {
																			handleDetailInputChange("detail", "pqq_submission_date", value);
																		}}
																		className="radio-group-class"
																	/>
																	<CalendarElement
																		id="pqq_submission_date"
																		className='ml-10'
																		defaultValue={parseDateString(opportunityData?.detail?.pqq_submission_date?.text)}
																		value={parseDateString(opportunityData?.detail?.pqq_submission_date?.text)}
																		onChange={(value) => {
																			handleCalenderDetailInputChange("detail", "pqq_submission_date", formatDate(value.value));
																		}}
																		maxLength="50"
																		placeholder="Date"
																		autocomplete="off"
																	/>
																</div>
															</div>
														}
														{
															_.find(props.detailsData?.projectDetailFields, { field_name: "ITT Issue Date" })?.field_status &&
															<div className="form-group row align-items-center mb-0 mt-0">
																<div className="col-md-4 pl-0">
																	<label className="form-label text-left">{props.detailsData?.projectDetailFields.find((project) => project?.field_name === "ITT Issue Date")?.display_name}:</label>
																</div>
																<div className="col-md-1 pl-0">
																	{
																		props.customerTooltipDataDetails?.critical_data.itt_issue_date?.status == true &&
																		<div>
																			<Tooltip target=".custom-target-icon" />
																			<i className="custom-target-icon pi pi-info-circle tooltip-font"
																				data-pr-tooltip={props.customerTooltipDataDetails?.critical_data.itt_issue_date?.text}
																				data-pr-position="right">
																			</i>
																		</div>
																	}
																</div>
																<div className='col pr-0 d-flex'>
																	<RadioElement
																		id="tender_due"
																		options={[{ key: "Est", name: "Est" }, { key: "Act", name: "Act" }]}
																		value={opportunityData?.tender_due?.radio}
																		onChangeRadio={(value) => {
																			handleInputChange("tender_due", value);
																		}}
																		className="radio-group-class"
																	/>
																	<CalendarElement
																		id="itt_issue_date"
																		name="itt_issue_date"
																		className='ml-10'
																		defaultValue={parseDateString(opportunityData?.tender_due?.text)}
																		value={parseDateString(opportunityData?.tender_due?.text)}
																		onChange={(value) => {
																			handleCalenderInputChange("tender_due", formatDate(value.value));
																		}}
																		maxLength="50"
																		placeholder="Date"
																		autocomplete="off"
																	/>
																</div>
															</div>
														}
														{
															_.find(props.detailsData?.projectDetailFields, { field_name: "ITT Submission Date" })?.field_status &&
															<div className="form-group row align-items-center mb-0 mt-0">
																<div className="col-md-4 pl-0">
																	<label className="form-label text-left">{props.detailsData?.projectDetailFields.find((project) => project?.field_name === "ITT Submission Date")?.display_name}:</label>
																</div>
																<div className="col-md-1 pl-0">
																	{
																		props.customerTooltipDataDetails?.critical_data?.itt_submission_date?.status == true &&
																		<div>
																			<Tooltip target=".custom-target-icon" />
																			<i className="custom-target-icon pi pi-info-circle tooltip-font"
																				data-pr-tooltip={props.customerTooltipDataDetails?.critical_data?.itt_submission_date?.text}
																				data-pr-position="right">
																			</i>
																		</div>
																	}
																</div>
																<div className='col pr-0 d-flex'>
																	<RadioElement
																		id="tender_due_out"
																		options={[{ key: "Est", name: "Est" }, { key: "Act", name: "Act" }]}
																		value={opportunityData?.tender_due_out?.radio}
																		onChangeRadio={(value) => {
																			handleInputChange("tender_due_out", value);
																		}}
																		className="radio-group-class"
																	/>
																	<CalendarElement
																		id="tender_due_out"
																		className='ml-10'
																		defaultValue={parseDateString(opportunityData?.tender_due_out?.text)}
																		value={parseDateString(opportunityData?.tender_due_out?.text)}
																		onChange={(value) => {
																			handleCalenderInputChange("tender_due_out", formatDate(value.value));
																		}}
																		maxLength="50"
																		placeholder="Date"
																		autocomplete="off"
																	/>
																</div>
															</div>
														}
														{
															_.find(props.detailsData?.projectDetailFields, { field_name: "Deadline for Enquiries" })?.field_status &&
															<div className="form-group row align-items-center mb-0 mt-0">
																<div className="col-md-4 pl-0">
																	<label className="form-label text-left">{props.detailsData?.projectDetailFields.find((project) => project?.field_name === "Deadline for Enquiries")?.display_name}:</label>
																</div>
																<div className="col-md-1 pl-0">
																	{
																		props.customerTooltipDataDetails?.critical_data?.deadline_for_enquiries?.status == true &&
																		<div>
																			<Tooltip target=".custom-target-icon" />
																			<i className="custom-target-icon pi pi-info-circle tooltip-font"
																				data-pr-tooltip={props.customerTooltipDataDetails?.critical_data?.deadline_for_enquiries?.text}
																				data-pr-position="right">
																			</i>
																		</div>
																	}
																</div>
																<div className='col pr-0 d-flex'>
																	<RadioElement
																		id="deadline_for_enquiries"
																		options={[{ key: "Est", name: "Est" }, { key: "Act", name: "Act" }]}
																		value={opportunityData?.detail?.deadline_for_enquiries?.radio}
																		onChangeRadio={(value) => {
																			handleDetailInputChange("detail", "deadline_for_enquiries", value);
																		}}
																		className="radio-group-class"
																	/>
																	<CalendarElement
																		id="deadline_for_enquiries"
																		className='ml-10'
																		defaultValue={parseDateString(opportunityData?.detail?.deadline_for_enquiries?.text)}
																		value={parseDateString(opportunityData?.detail?.deadline_for_enquiries?.text)}
																		onChange={(value) => {
																			handleCalenderDetailInputChange("detail", "deadline_for_enquiries", formatDate(value.value));
																		}}
																		maxLength="50"
																		placeholder="Date"
																		autocomplete="off"
																	/>
																</div>
															</div>
														}
														{customerShort && customerShort !== process.env.REACT_APP_JMAN && customerShort !==  process.env.REACT_APP_VM &&
															_.find(props.detailsData?.projectDetailFields, { field_name: "Tender period" })?.field_status &&
															<div className="form-group row align-items-center mb-0 mt-0">
																<div className="col-md-4 pl-0">
																	<label className="form-label text-left">{props.detailsData?.projectDetailFields.find((project) => project?.field_name === "Tender period")?.display_name}:</label>
																</div>
																<div className="col-md-1 pl-0">
																	{
																		props.customerTooltipDataDetails?.critical_data?.tender_period?.status == true &&
																		<div>
																			<Tooltip target=".custom-target-icon" />
																			<i className="custom-target-icon pi pi-info-circle tooltip-font"
																				data-pr-tooltip={props.customerTooltipDataDetails?.critical_data?.tender_period?.text}
																				data-pr-position="right">
																			</i>
																		</div>
																	}
																</div>
																<div className='col pr-0 d-flex'>
																	<RadioElement
																		id="tender_period"
																		options={[{ key: "Est", name: "Est" }, { key: "Act", name: "Act" }]}
																		value={opportunityData?.detail?.tender_period?.radio}
																		onChangeRadio={(value) => {
																			handleDetailInputChange("detail", "tender_period", value);
																		}}
																		className="radio-group-class"
																	/>
																	<div className='col pr-0'>
																		<InputTextElementElement
																			value={opportunityData?.detail?.tender_period?.text}
																			placeholder=""
																			name="tender_period"
																			className="w-full"
																			disabled
																		/>
																	</div>
																</div>
															</div>
														}
														{customerShort && (customerShort === process.env.REACT_APP_JMAN || customerShort ===  process.env.REACT_APP_VM) &&
															_.find(props.detailsData?.projectDetailFields, { field_name: "Tender period" })?.field_status &&
															<div className="form-group row align-items-center mb-0 mt-0">
																<div className="col-md-4 pl-0">
																	<label className="form-label text-left">{props.detailsData?.projectDetailFields.find((project) => project?.field_name === "Tender period")?.display_name}:</label>
																</div>
																<div className="col-md-1 pl-0">
																	{
																		props.customerTooltipDataDetails?.critical_data?.tender_period?.status == true &&
																		<div>
																			<Tooltip target=".custom-target-icon" />
																			<i className="custom-target-icon pi pi-info-circle tooltip-font"
																				data-pr-tooltip={props.customerTooltipDataDetails?.critical_data?.tender_period?.text}
																				data-pr-position="right">
																			</i>
																		</div>
																	}
																</div>
																<div className='col pr-0 d-flex'>
																	<RadioElement
																		id="tender_period"
																		options={[{ key: "Est", name: "Est" }, { key: "Act", name: "Act" }]}
																		value={opportunityData?.detail?.tender_period?.radio}
																		onChangeRadio={(value) => {
																			handleDetailInputChange("detail", "tender_period", value);
																		}}
																		className="radio-group-class"
																	/>
																	<div className='col pr-0'>
																		{/* <InputTextElementElement
																			value={opportunityData?.detail?.tender_period?.text}
																			placeholder=""
																			name="tender_period"
																			className="w-full"
																			disabled
																		/> */}
																		<CalendarElement
																		id="tender_period"
																		className='ml-10'
																		defaultValue={parseDateString(opportunityData?.detail?.tender_period?.text)}
																		value={parseDateString(opportunityData?.detail?.tender_period?.text)}
																		onChange={(value) => {
																			handleCalenderDetailInputChange("detail", "tender_period", formatDate(value.value));
																		}}
																		maxLength="50"
																		placeholder="Date"
																		autocomplete="off"
																	/>
																	</div>
																</div>
															</div>
														}
													</div>
													<div className='col-md-6 pl-0'>
														{
															_.find(props.detailsData?.projectSumFields, { field_name: "Project Start Date" })?.field_status &&
															<div className="form-group row align-items-center mb-0 mt-0">
																<div className="col-md-4 pl-0">
																	<label className="form-label text-left">{props.detailsData?.projectSumFields.find((project) => project?.field_name === "Project Start Date")?.display_name}:</label>
																</div>
																<div className="col-md-1 pl-0">
																</div>
																<div className='col pr-0 d-flex'>
																	<RadioElement
																		id="contract_start_date_summary"
																		options={[{ key: "Est", name: "Est" }, { key: "Act", name: "Act" }]}
																		value={opportunityData?.summary?.contract_start_date_summary?.radio}
																		onChangeRadio={(value) => {
																			handleDetailInputChange("summary", "contract_start_date_summary", value);
																		}}
																		className="radio-group-class"
																	/>
																	<CalendarElement
																		id="contract_start_date_summary"
																		className='ml-10'
																		value={parseDateString(opportunityData?.summary?.contract_start_date_summary?.text)}
																		onChange={(value) => {
																			handleCalenderStartEnd("summary", "contract_start_date_summary", formatDate(value.value));
																		}}
																		maxLength="50"
																		placeholder="Date"
																		autocomplete="off"
																	/>
																</div>
															</div>
														}
														{
															_.find(props.detailsData?.projectSumFields, { field_name: "Project End Date" })?.field_status &&
															<div className="form-group row align-items-center mb-0 mt-0">
																<div className="col-md-4 pl-0">
																	<label className="form-label text-left">{props.detailsData?.projectSumFields.find((project) => project?.field_name === "Project End Date")?.display_name}:</label>
																</div>
																<div className="col-md-1 pl-0">
																</div>
																<div className='col pr-0 d-flex'>
																	<RadioElement
																		id="contract_end_date_summary"
																		options={[{ key: "Est", name: "Est" }, { key: "Act", name: "Act" }]}
																		value={opportunityData?.summary?.contract_end_date_summary?.radio}
																		onChangeRadio={(value) => {
																			handleDetailInputChange("summary", "contract_end_date_summary", value);
																		}}
																		className="radio-group-class"
																	/>
																	<CalendarElement
																		id="contract_end_date_summary"
																		className='ml-10'
																		value={parseDateString(opportunityData?.summary?.contract_end_date_summary?.text)}
																		onChange={(value) => {
																			handleCalenderStartEnd("summary", "contract_end_date_summary", formatDate(value.value));
																		}}
																		maxLength="50"
																		placeholder="Date"
																		autocomplete="off"
																	/>
																</div>
															</div>
														}
														{
															_.find(props.detailsData?.projectSelectFields, { field_name: "Project Duration" })?.field_status &&
															<div className="form-group row align-items-center mb-0 mt-0">
																<div className="col-md-4 pl-0">
																	<label className="form-label text-left">{props.detailsData?.projectSelectFields.find((project) => project?.field_name === "Project Duration")?.display_name}:</label>
																</div>
																<div className="col-md-1 pl-0">
																	{
																		props.customerTooltipDataDetails?.critical_data.project_duration.status == true &&
																		<div>
																			<Tooltip target=".custom-target-icon" />
																			<i className="custom-target-icon pi pi-info-circle tooltip-font"
																				data-pr-tooltip={props.customerTooltipDataDetails?.critical_data?.project_duration?.text}
																				data-pr-position="right">
																			</i>
																		</div>
																	}
																</div>
																<div className='col pr-0 d-flex'>
																	<RadioElement
																		id="project_duration"
																		options={[{ key: "Est", name: "Est" }, { key: "Act", name: "Act" }]}
																		value={opportunityData?.detail?.project_duration?.radio}
																		onChangeRadio={(value) => {
																			handleDetailInputChange("detail", "project_duration", value);
																		}}
																		className="radio-group-class"
																	/>
																	<div className='col pr-0'>
																		<InputTextElementElement
																			value={opportunityData?.detail?.project_duration?.text}
																			placeholder=""
																			name="project_duration"
																			className="w-full"
																			disabled
																		/>
																	</div>
																</div>
															</div>
														}
														{
															_.find(props.detailsData?.projectSumFields, { field_name: "Total Contract Value" })?.field_status &&
															<div className="form-group row align-items-center mb-0 mt-0">
																<div className="col-md-4 pl-0">
																	<label className="form-label text-left">{props.detailsData?.projectSumFields.find((project) => project?.field_name === "Total Contract Value")?.display_name + ' (' + props.currency + ') '}:</label>
																</div>
																<div className="col-md-1 pl-0">
																</div>
																<div className='col pr-0 d-flex'>
																	<label className="form-label text-left">{props.currency + ' ' + opportunityData?.total_contract_value?.text}</label>
																</div>
															</div>
														}
														{
															_.find(props.detailsData?.projectDetailFields, { field_name: "Site Visit Date" })?.field_status &&
															<div className="form-group row align-items-center mb-0 mt-0">
																<div className="col-md-4 pl-0">
																	<label className="form-label text-left">{props.detailsData?.projectDetailFields.find((project) => project?.field_name === "Site Visit Date")?.display_name}:</label>
																</div>
																<div className="col-md-1 pl-0">
																	{
																		props.customerTooltipDataDetails?.critical_data?.opportunity_received_date?.status == true &&
																		<div>
																			<Tooltip target=".custom-target-icon" />
																			<i className="custom-target-icon pi pi-info-circle tooltip-font"
																				data-pr-tooltip={props.customerTooltipDataDetails?.critical_data?.opportunity_received_date?.text}
																				data-pr-position="right">
																			</i>
																		</div>
																	}
																</div>
																<div className='col pr-0 d-flex'>
																	<RadioElement
																		id="opportunity_received_date"
																		options={[{ key: "Est", name: "Est" }, { key: "Act", name: "Act" }]}
																		value={opportunityData?.detail?.opportunity_received_date?.radio}
																		onChangeRadio={(value) => {
																			handleDetailInputChange("detail", "opportunity_received_date", value);
																		}}
																		className="radio-group-class"
																	/>
																	<CalendarElement
																		id="opportunity_received_date"
																		className='ml-10'
																		defaultValue={parseDateString(opportunityData?.detail?.opportunity_received_date?.text)}
																		value={parseDateString(opportunityData?.detail?.opportunity_received_date?.text)}
																		onChange={(value) => {
																			handleCalenderDetailInputChange("detail", "opportunity_received_date", formatDate(value.value));
																		}}
																		maxLength="50"
																		placeholder="Date"
																		autocomplete="off"
																	/>
																</div>
															</div>
														}
														{
															_.find(props.detailsData?.projectDetailFields, { field_name: "Site Start Date" })?.field_status &&
															<div className="form-group row align-items-center mb-0 mt-0">
																<div className="col-md-4 pl-0">
																	<label className="form-label text-left">{props.detailsData?.projectDetailFields?.find((project) => project?.field_name === "Site Start Date")?.display_name}:</label>
																</div>
																<div className="col-md-1 pl-0">
																	{
																		props.customerTooltipDataDetails?.critical_data?.site_start_date?.status == true &&
																		<div>
																			<Tooltip target=".custom-target-icon" />
																			<i className="custom-target-icon pi pi-info-circle tooltip-font"
																				data-pr-tooltip={props.customerTooltipDataDetails?.critical_data?.site_start_date?.text}
																				data-pr-position="right">
																			</i>
																		</div>
																	}
																</div>
																<div className='col pr-0 d-flex'>
																	<RadioElement
																		id="site_start_date"
																		options={[{ key: "Est", name: "Est" }, { key: "Act", name: "Act" }]}
																		value={opportunityData?.detail?.site_start_date?.radio}
																		onChangeRadio={(value) => {
																			handleDetailInputChange("detail", "site_start_date", value);
																		}}
																		className="radio-group-class"
																	/>
																	<CalendarElement
																		id="site_start_date"
																		className='ml-10'
																		defaultValue={parseDateString(opportunityData?.detail?.site_start_date?.text)}
																		value={parseDateString(opportunityData?.detail?.site_start_date?.text)}
																		onChange={(value) => {
																			handleCalenderDetailInputChange("detail", "site_start_date", formatDate(value.value));
																		}}
																		maxLength="50"
																		placeholder="Date"
																		autocomplete="off"
																	/>
																</div>
															</div>
														}
													</div>
												</div>
											}
											{
												key == 'obj3' &&
												<div className="new-field d-flex">
													<div className='col-md-6 pl-0'>
														{
															_.find(props.detailsData?.projectDetailFields, { field_name: "Sub-Contractor - Main Contractor Bid Status" })?.field_status && (
																<div className="form-group row align-items-center mb-0 mt-0">
																	<div className="col-md-4 pl-0">
																		<label className="form-label text-left">{_.find(props.detailsData?.projectDetailFields, { field_name: "Sub-Contractor - Main Contractor Bid Status" })?.display_name}:</label>
																	</div>
																	<div className="col-md-1 pl-0">
																		{
																			props.customerTooltipDataDetails?.subcontractor_details?.sub_contractor_main_contractor?.status == true &&
																			<div>
																				<Tooltip target=".custom-target-icon" />
																				<i className="custom-target-icon pi pi-info-circle tooltip-font"
																					data-pr-tooltip={props.customerTooltipDataDetails?.subcontractor_details?.sub_contractor_main_contractor?.text}
																					data-pr-position="right">
																				</i>
																			</div>
																		}
																	</div>
																	<div className="col-md-7 pr-0 pad-t-8 pad-b-8">
																		<Controller
																			name="SubMainContractorBidStatus"
																			control={control}
																			defaultValue={editData.additional?.sub_contractor_main_contractor}
																			style={{ innerHeight: 10 }}
																			render={({ field }) => (
																				<DropdownElement
																					onChangeValue={(e) => field.onChange(e.value)}
																					name="SubMainContractorBidStatus"
																					options={(subMainContractorBidStatusOpts != undefined && subMainContractorBidStatusOpts.length > 0) ? subMainContractorBidStatusOpts : []}
																					optionLabel="label"
																					placeholder="-- Please select --"
																					className="w-full"
																					{...field}
																					maxSelectedLabels={1}
																					value={field.value || editData.additional?.sub_contractor_main_contractor}
																					// ref={(el) => {
																					// 	props.setElement((prevData) => ({
																					// 		...prevData,
																					// 		["SubMainContractorBidStatus"]: el,
																					// 	}));
																					// }}
																					onChange={(e) => {
																						setGlobalOpportunityData((prevData) => ({
																							...prevData,
																							additional: {
																								...prevData.additional,
																								sub_contractor_main_contractor: e.value.label
																							}
																						}));
																						props.computeScore(0, "SubMainContractorBidStatus", e.value, editData.additional?.sub_contractor_main_contractor);
																						field.onChange(e.value)
																					}
																					}
																				/>
																			)}
																		/>
																	</div>
																</div>
															)
														}
														{
															_.find(props.detailsData?.projectDetailFields, { field_name: "Subcontractor Submission Date" })?.field_status &&
															<div className="form-group row align-items-center mb-0 mt-0">
																<div className="col-md-4 pl-0">
																	<label className="form-label text-left">{_.find(props.detailsData?.projectDetailFields, { field_name: "Subcontractor Submission Date" })?.display_name}:</label>
																</div>
																<div className="col-md-1 pl-0">
																	{
																		props.customerTooltipDataDetails?.subcontractor_details?.subcontractor_submission_date?.status == true &&
																		<div>
																			<Tooltip target=".custom-target-icon" />
																			<i className="custom-target-icon pi pi-info-circle tooltip-font"
																				data-pr-tooltip={props.customerTooltipDataDetails?.subcontractor_details?.subcontractor_submission_date?.text}
																				data-pr-position="right">
																			</i>
																		</div>
																	}
																</div>
																<div className='col pr-0 d-flex'>
																	<RadioElement
																		name="subcontractor_submission_date"
																		options={[{ key: "Est", name: "Est" }, { key: "Act", name: "Act" }]}
																		value={opportunityData?.detail?.subcontractor_submission_date?.radio}
																		onChangeRadio={(value) => {
																			handleDetailInputChange("detail", "subcontractor_submission_date", value);
																		}}
																		className="radio-group-class"
																	/>
																	<CalendarElement
																		id="subcontractor_submission_date"
																		className='ml-10'
																		defaultValue={parseDateString(opportunityData?.detail?.subcontractor_submission_date?.text)}
																		value={parseDateString(opportunityData?.detail?.subcontractor_submission_date?.text)}
																		onChange={(value) => {
																			handleCalenderDetailInputChange("detail", "subcontractor_submission_date", formatDate(value.value));
																		}}
																		maxLength="50"
																		placeholder="Date"
																		autocomplete="off"
																	/>
																</div>
															</div>
														}
													</div>
													<div className='col-md-6 pl-0'>
														{
															_.find(props.detailsData?.projectDetailFields, { field_name: "Sub-contractor Information Requirement" })?.field_status &&
															<div className="form-group row align-items-center mb-0 mt-0">
																<div className="col-md-4 pl-0">
																	<label className="form-label text-left">{_.find(props.detailsData?.projectDetailFields, { field_name: "Sub-contractor Information Requirement" })?.display_name}:</label>
																</div>
																<div className="col-md-1 pl-0">
																	{
																		props.customerTooltipDataDetails?.subcontractor_details?.subcontractor_information_requirement?.status == true &&
																		<div>
																			<Tooltip target=".custom-target-icon" />
																			<i className="custom-target-icon pi pi-info-circle tooltip-font"
																				data-pr-tooltip={props.customerTooltipDataDetails?.subcontractor_details?.subcontractor_information_requirement?.text}
																				data-pr-position="right">
																			</i>
																		</div>
																	}
																</div>
																<div className='col pr-0 d-flex'>
																	<RadioElement
																		id="subcontractor_information_requirement"
																		options={[{ key: "Est", name: "Est" }, { key: "Act", name: "Act" }]}
																		value={opportunityData?.detail?.subcontractor_information_requirement?.radio}
																		onChangeRadio={(value) => {
																			handleDetailInputChange("detail", "subcontractor_information_requirement", value);
																		}}
																		className="radio-group-class"
																	/>
																	<CalendarElement
																		id="subcontractor_information_requirement"
																		className='ml-10'
																		defaultValue={parseDateString(opportunityData?.detail?.subcontractor_information_requirement?.text)}
																		value={parseDateString(opportunityData?.detail?.subcontractor_information_requirement?.text)}
																		onChange={(value) => {
																			handleCalenderDetailInputChange("detail", "subcontractor_information_requirement", formatDate(value.value));
																		}}
																		maxLength="50"
																		placeholder="Date"
																		autocomplete="off"
																	/>
																</div>
															</div>
														}
														{
															_.find(props.detailsData?.projectDetailFields, { field_name: "Sub-contractor Design Workshops" })?.field_status &&
															<div className="form-group row align-items-center mb-0 mt-0">
																<div className="col-md-4 pl-0">
																	<label className="form-label text-left">{_.find(props.detailsData?.projectDetailFields, { field_name: "Sub-contractor Design Workshops" })?.display_name}:</label>
																</div>
																<div className="col-md-1 pl-0">
																	{
																		props.customerTooltipDataDetails?.subcontractor_details?.subcontractor_design_workshops?.status == true &&
																		<div>
																			<Tooltip target=".custom-target-icon" />
																			<i className="custom-target-icon pi pi-info-circle tooltip-font"
																				data-pr-tooltip={props.customerTooltipDataDetails?.subcontractor_details?.subcontractor_design_workshops?.text}
																				data-pr-position="right">
																			</i>
																		</div>
																	}
																</div>
																<div className='col pr-0 d-flex'>
																	<RadioElement
																		id="subcontractor_design_workshops"
																		options={[{ key: "Est", name: "Est" }, { key: "Act", name: "Act" }]}
																		value={opportunityData?.detail?.subcontractor_design_workshops?.radio}
																		onChangeRadio={(value) => {
																			handleDetailInputChange("detail", "subcontractor_design_workshops", value);
																		}}
																		className="radio-group-class"
																	/>
																	<CalendarElement
																		id="subcontractor_design_workshops"
																		className='ml-10'
																		defaultValue={parseDateString(opportunityData?.detail?.subcontractor_design_workshops?.text)}
																		value={parseDateString(opportunityData?.detail?.subcontractor_design_workshops?.text)}
																		onChange={(value) => {
																			handleCalenderDetailInputChange("detail", "subcontractor_design_workshops", formatDate(value.value));
																		}}
																		maxLength="50"
																		placeholder="Date"
																		autocomplete="off"
																	/>
																</div>
															</div>
														}
													</div>
												</div>
											}
										</AccordionTab>
									}
								</Accordion>
							</div>
						))
					}
					<Dialog id="videoModal" visible={showVideo}
                        breakpoints={{
                            '1200px': '80vw',    // Larger modal on bigger screens
                            '1024px': '85vw',    // Slightly smaller for medium screens
                            '769': '90vw',     // Responsive on tablets
                            '641px': '95vw',     // Almost full-width on mobile
                        }}
                        modal className="table-dialog width-32" draggable={false} width="800px" height="500px" onHide={closeVideo}
                    >
                        <div className="video-overlay">
                            <div className="video-container">
                                <PlaylistVideos playlistId={process.env.REACT_APP_PORTFOLIO_PLAYLIST_ID} apiKey={process.env.REACT_APP_GOOGLE_API_KEY} module="summary" />
                            </div>
                        </div>
                    </Dialog>
				</form>
			}
		</div>
	);
})

export default Detail;